/**
 * LegalPage.jsx — Contracts / Legal Documents (MUI)
 */
import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import LegalList from '../components/legal/LegalList';
import ICAGenerator from '../components/legal/ICAGenerator';
import { useMobile } from '../hooks/useMobile';

export default function LegalPage() {
  const { isMobile } = useMobile();
  const [activeTab, setActiveTab] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const t = searchParams.get('tab');
    if (t === '0' || t === '1') { setActiveTab(Number(t)); searchParams.delete('tab'); setSearchParams(searchParams, { replace: true }); }
  }, [searchParams, setSearchParams]);
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: isMobile ? 'calc(100dvh - 84px)' : 'calc(100dvh - 8rem)', gap: 2 }}>
      <Typography variant="h5" sx={{ fontFamily: '"Bebas Neue", sans-serif', letterSpacing: 1 }}>Legal</Typography>
      <Tabs value={activeTab} onChange={(_, v) => setActiveTab(v)} sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tab label="Documents" sx={{ textTransform: 'none' }} />
        <Tab label="ICA Generator" sx={{ textTransform: 'none' }} />
      </Tabs>
      <Box sx={{ flex: 1, minHeight: 0 }}>
        {activeTab === 0 && <LegalList />}
        {activeTab === 1 && <ICAGenerator />}
      </Box>
    </Box>
  );
}
